import { render, staticRenderFns } from "./ComparingAnswerModal.vue?vue&type=template&id=1b0e1a69&scoped=true&"
import script from "./ComparingAnswerModal.vue?vue&type=script&lang=ts&"
export * from "./ComparingAnswerModal.vue?vue&type=script&lang=ts&"
import style0 from "./ComparingAnswerModal.vue?vue&type=style&index=0&id=1b0e1a69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0e1a69",
  null
  
)

export default component.exports